import Base from "../base";

export default {
  prepare: (cafeLink) => Base.get(`/preview/${cafeLink}/prepare`),
};
